export default __webpack_public_path__ + "static/media/push10.2225f98a.gif";